export default __webpack_public_path__ + "static/media/mac_video.b27bb59e.m4v";